module.exports = __webpack_public_path__ + "img/filter.74c209bf.svg";